import Spinner from "./UxbiSpinner";
import React from "react";
import { Button, Alert, Modal, Form } from "react-bootstrap";
import {
  Plus,
  RefreshCw,
  Search,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
export const money = (v, c = "MXN") =>
  new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: /^[A-Z]{3}$/.test(c) ? c : "MXN",
  }).format(Number(v || 0));
export const date = (v) => (v ? String(v).slice(0, 10) : "—");
export function Header({ title, description, action, onNew }) {
  return (
    <header className="module-heading">
      <div>
        <div className="eyebrow">UXBI · PIEDRAS VIVAS</div>
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      {onNew && (
        <Button onClick={onNew}>
          <Plus size={18} />
          {action || "Nuevo"}
        </Button>
      )}
    </header>
  );
}
export function Toolbar({ search, onSearch, onReload, loading, children }) {
  return (
    <div className="toolbar">
      <label className="search">
        <Search size={18} />
        <input
          aria-label="Buscar registros"
          placeholder="Buscar…"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
        />
      </label>
      {children}
      <Button
        variant="light"
        onClick={onReload}
        disabled={loading}
        aria-label="Actualizar"
      >
        {loading ? <Spinner size="sm" /> : <RefreshCw size={18} />}
      </Button>
    </div>
  );
}
export function Status({ loading, error, onRetry }) {
  return error ? (
    <Alert variant="danger">
      {error}{" "}
      <Button variant="link" onClick={onRetry}>
        Reintentar
      </Button>
    </Alert>
  ) : loading ? (
    <div className="panel-loading">
      <Spinner />
      <span>Consultando información…</span>
    </div>
  ) : null;
}
export function Pager({ data, page, setPage }) {
  if (!data) return null;
  return (
    <div className="pager">
      <span>
        {data.total || 0} registros · Página {page} de {data.last_page || 1}
      </span>
      <div>
        <Button
          variant="light"
          disabled={page <= 1}
          onClick={() => setPage(page - 1)}
          aria-label="Página anterior"
        >
          <ChevronLeft size={18} />
        </Button>
        <Button
          variant="light"
          disabled={page >= (data.last_page || 1)}
          onClick={() => setPage(page + 1)}
          aria-label="Página siguiente"
        >
          <ChevronRight size={18} />
        </Button>
      </div>
    </div>
  );
}
export function Confirm({ title, children, onClose, onConfirm, busy }) {
  return (
    <Modal show onHide={busy ? undefined : onClose} centered>
      <Modal.Header closeButton={!busy}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <Button variant="light" disabled={busy} onClick={onClose}>
          Volver
        </Button>
        <Button disabled={busy} onClick={onConfirm}>
          {busy ? <Spinner size="sm" /> : "Confirmar"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
export const Field = ({ label, value, onChange, type = "text", ...props }) => (
  <Form.Group className="mb-3">
    <Form.Label>{label}</Form.Label>
    <Form.Control
      type={type}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      {...props}
    />
  </Form.Group>
);
